import React, { useEffect, useState } from "react";
import Menubar from "../Menubar";
import { Container, Row, Col, Table } from "react-bootstrap";
import { store } from "../../App";
import { AiFillFileExcel, AiOutlineSearch } from "react-icons/ai";
import { MdOutlinePictureAsPdf } from "react-icons/md";
import autoTable from "jspdf-autotable";
import { exportToExcel, datetime, generatePdf, commonSelectProps,} from "../utils/commonFunctions";
import KpiService from "../../Services/KpiService";
import AlertModal from "../Alert/AlertModal";
import useAlert from "../Alert/useAlert";import Select from 'react-select';
import { Field, FormikProvider, Form, useFormik } from "formik";
import MasterService from "../../Services/MasterService";

export default function DistrictMandalEntryStatusReport() {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert(); const [currentdate, setcurrentdate] = useState(""); const [currenttime, setcurrenttime] = useState(""); const [data, setData] = useState([]); const [searchText, setSearch] = useState(""); const [yearList,setYearList] = useState([]);
   const [monthList,setMonthList] = useState([]);
   const [distlist, setDistrictList] = useState();
   const [Deptlist, setDeptlist] = useState([]);
   let roleid = localStorage.getItem("catid");
  let deptid = localStorage.getItem("deptid");
  let district = localStorage.getItem("districtid");
  let username = localStorage.getItem("username");
  const formik = useFormik({
    initialValues: {
      year: "",month:"",department_id:"",district_id:""
    },
  });

  useEffect(() => {
    datetime(setcurrentdate, setcurrenttime);
     MasterService.getfinyears().then((finachievres) => {
      if (finachievres.data) {
         let options = finachievres.data.map((item, i) => {
            return ( <option key={i} value={item.id}> {item.value} </option> );
          });
           setYearList(finachievres.data);
        }
      });
let params={"userId":username}
       MasterService.getkpiMonths(params).then((finachievres) => {
      if (finachievres.data) {
        
           setMonthList(finachievres.data.SDESC);
        }
      });
   if(roleid==="115"){
        let param={ deptId:localStorage.getItem("secretariat_code")} 
 KpiService.getDeptartmentsWithoutToken(param).then((res) => {
      if (res.data.SDESC) {
       
        setDeptlist(res.data.SDESC);
      }
    });
  }
  else{
    MasterService.getDeptartments(params).then((res) => {
      if (res.data.SDESC) {
       
        setDeptlist([ { dept_id: "0", dept_name: "All",deptcode:"" }, ...(res.data.SDESC ?? []) ]);
      }
    });
  }
       MasterService.getDistricts().then((res17) => {
      if (res17.data) {
      setDistrictList(res17.data);
      }


    });
if(["113","114","111"].includes(roleid) ){
      formik.setFieldValue("department_id",deptid);
    }
    if(["113","119","111","117"].includes(roleid) ){
      formik.setFieldValue("district_id",district);
    }
  }, []);

  const getData = (monthh) => {
    if (!monthh) { showAlertMessage("Year Required", "error"); setData([]); return; }
    let dept="";
    if(roleid ==="115"){dept=Deptlist.find(item=>item.dept_id===formik.values.department_id).deptcode;}else{dept=formik.values.department_id;}
    let kpiabstractparams = { userId: username, year:formik.values.year, monthOrder:monthh, deptId:dept, districtId:["113","119","111","117"].includes(roleid)? district:"0" };
    store.dispatch({ type: "SHOW_SPINNER" });
    KpiService.districtAndMandalEntryStatusReport(kpiabstractparams)
      .then((kpiabsres) => {
        if (kpiabsres.data && kpiabsres.data.SCODE == "01") {
          setData(kpiabsres.data.dataList);
        } else {
          setData([]);
        }
      }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };

  const filteredData =
    searchText.length > 0 && data?.length
      ? data.filter((item) => {
          return ( item && Object.keys(item).some((key) => { const value = item[key]; return value !== null && value.toString().toLowerCase().includes(searchText.toLowerCase()); }) );
        })
      : data;

const AreaWise = [ { name: "Secretariat" }, { name: "HOD" }, { name: "District" }, { name: "Mandal" } ]; const PeriodWise = [ { name: "Monthly" }, { name: "Quarterly" }, { name: "Half yearly" }, { name: "Annually" }, { name: "Biennial" }, { name: "Five Years" } ]; const periodSubColumns = { Monthly: [ { value: "apr", label: "Apr" }, { value: "may", label: "May" }, { value: "jun", label: "Jun" }, { value: "jul", label: "Jul" }, { value: "aug", label: "Aug" }, { value: "sep", label: "Sep" }, { value: "oct", label: "Oct" }, { value: "nov", label: "Nov" }, { value: "dec", label: "Dec" }, { value: "jan", label: "Jan" }, { value: "feb", label: "Feb" }, { value: "mar", label: "Mar" }, ], Quarterly: [ { value: "q1", label: "Q1 (Apr-Jun)" }, { value: "q2", label: "Q2 (Jul-Sep)" }, { value: "q3", label: "Q3 (Oct-Dec)" }, { value: "q4", label: "Q4 (Jan-Mar)" }, ], "Half yearly": [ { value: "hy1", label: "HY-1" }, { value: "hy2", label: "HY-2" }, ], Annually: [], Biennial: [], "Five Years": [], }; const [expandedCols, setExpandedCols] = useState([]);

  return (
    <>
      <Menubar />
      <Container fluid style={{ width: "97%" }}> <div className="sa-title"> <h2> District and Mandal Entry<span> Status Report </span> </h2> </div> </Container>
      <Container fluid style={{ width: "97%" }} className="outer-page-content-container">
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <div className="mandal-container py-2 px-4 mb-3">
              <Row>
                <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                  <label htmlFor="department_id" className="mb-1 fw-bold"> HOD Name </label>
                  <Select {...commonSelectProps({ name: "department_id", options: Deptlist, value: formik.values.department_id, optionValueKey: "dept_id", optionLabelKey: "dept_name", formik, 
                    isDisabled: ["111", "113", "114"].includes(roleid), extraOnChange: (option) => { formik.setFieldValue("year",""); formik.setFieldValue("month",""); setData([]);
                     } })} />
                  
                </Col>
                {["113","119","111","117"].includes(roleid) && 
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className="district-select">
                  <label className="mb-1 fw-bold"> District </label> <span style={{ color: "red" }}> *</span>
                  <Select {...commonSelectProps({ name: "district_id", options: distlist, value: formik.values.district_id, optionValueKey: "id", optionLabelKey: "value", formik, isDisabled: true, 
                    extraOnChange: (option) => {  } })} />
                 
                </Col>
}
                <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                     <label className="mb-1 fw-bold"> Financial Year </label> <span style={{ color: "red" }}> *</span>
                                                    <Select
  {...commonSelectProps({
    name: "year",
    options: yearList,
    value: formik.values.year,
    optionValueKey: "id",
    optionLabelKey: "value",
    formik,
    isDisabled: false,

    extraOnChange: (option) => {
formik.setFieldValue("month",""); setData([]);
    }
  })}
/>   
                                                   </Col>

                                                   <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3}>
                                                     <label className="mb-1 fw-bold"> Month</label> <span style={{ color: "red" }}> *</span>
                                                    <Select
  {...commonSelectProps({
    name: "month",
    options: monthList,
    value: formik.values.month,
    optionValueKey: "month_order",
    optionLabelKey: "month_name",
    formik,
    isDisabled: false,

    extraOnChange: (option) => {
getData(option?option.month_order:"");
    }
  })}
/>   
                                                   </Col>
              </Row>
            </div>
          </Form>
        </FormikProvider>

        <Row>
          <Col xs={12} sm={12} md={3} lg={3} xl={3} xxl={3} className=" mb-3">
            <div style={{ display: "flex", border: "1px solid #ddd",  alignItems: "center",borderRadius: "20px",transition: "all 0.3s ease-in-out", backgroundColor: "#fff",  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", padding: "5px 10px", width: "150px", minWidth: "150px" }} id="search-container">
              <AiOutlineSearch className="me-2" style={{ fontSize: "1.2rem", color: "#888", visibility: "visible" }} />
              <input type="text" placeholder="Search" value={searchText} onChange={(e) => setSearch(e.target.value)} onFocus={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.2)"; parent.style.border = "1px solid #353935"; parent.style.width = "100%"; }} onBlur={(e) => { const parent = e.currentTarget.parentElement; parent.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)"; parent.style.border = "1px solid #ddd"; parent.style.width = "150px"; }} style={{ flex: "1", border: "none", outline: "none", fontSize: "1rem", color: "#333", backgroundColor: "transparent", transition: "color 0.3s ease", minWidth: "0" }} />
            </div>
          </Col>
          <Col className="mb-2">
            <button className="btn btn-danger btn-sm mx-2 pdf-btn" onClick={() => generatePdf("#my-table", "DistrictMandalEntryStatusReport",41)} style={{ float: "right", marginLeft: "3px" }}> PDF <MdOutlinePictureAsPdf /> </button> <button size="sm" className="btn mx-2 excel-btn" style={{ float: "right", color: "#ffffff", marginLeft: "3px" }} onClick={() => exportToExcel("my-table", "DistrictMandalEntryStatusReport")}> Excel <AiFillFileExcel style={{ fontSize: "18px" }} /> </button>
          </Col>
        </Row>

        <div style={{ textAlign: "center", backgroundColor: "#d4e3d8" }} className="rounded-1 border py-1"> <span className="style"> Abstract of District Mandal Data Entry Status for the Month of : {monthList.find(item => item.month_order === formik.values.month)?.month_name}</span> <div className="text-end style-1"> Report On : {currentdate} {currenttime} </div> </div>
        <div id="table-scroll" className="table-scroll">
          <div className="table-wrap">
        <Table bordered id="my-table" className="table table-bordered custom-table table-responsive sticky-table">
  <thead>
  {/* ROW 1 */}
  <tr className="text-center">
    <th rowSpan={3} className="sticky-col sticky-sno">Sl.No.</th>
    <th rowSpan={3} className="sticky-col sticky-KPIHOD indicator-column">District Name</th>

    <th colSpan={11}>Targets</th>
    <th colSpan={14}>Achievements Completed</th>
    <th colSpan={14}>Achievements Not Completed</th>
  </tr>

  {/* ROW 2 */}
  <tr className="text-center">
    {/* Targets */}
    <th colSpan={2}>Monthly Indicators</th>
    <th colSpan={2}>Quarterly Indicators</th>
    <th colSpan={2}>Half Yearly Indicators</th>
    <th colSpan={2}>Annual Indicators</th>
    <th colSpan={2}>Total Targets</th>
    <th colSpan={1}>Total</th>

    {/* Achievements Completed */}
    <th colSpan={2}>Monthly Indicators</th>
    <th colSpan={2}>Quarterly Indicators</th>
    <th colSpan={2}>Half Yearly Indicators</th>
    <th colSpan={2}>Annual Indicators</th>
    <th colSpan={2}>Total Completed</th>
    <th colSpan={1}>Total</th>
    <th colSpan={2}>%</th>
    <th colSpan={1}>Total %</th>

    {/* Achievements Not Completed */}
    <th colSpan={2}>Monthly Indicators</th>
    <th colSpan={2}>Quarterly Indicators</th>
    <th colSpan={2}>Half Yearly Indicators</th>
    <th colSpan={2}>Annual Indicators</th>
    <th colSpan={2}>Total Not Completed</th>
    <th colSpan={1}>Total</th>
    <th colSpan={2}>%</th>
    <th colSpan={1}>Total %</th>
  </tr>

  {/* ROW 3 */}
 <tr className="text-center">
  {Array.from({ length: 22 }).map((_, index) => {
    if ([5, 11,19].includes(index)) {
      return (
        <th key={index}>D+M</th>
      );
    }
 if ([13,21].includes(index)) {
      return (
        <th key={index}>%</th>
      );
    }
    return (
      <React.Fragment key={index}>
        <th>District</th>
        <th>Mandal</th>
      </React.Fragment>
    );
  })}
</tr>

</thead>


 <tbody>
  {filteredData.length === 0 ? (
    <tr>
      <td colSpan="100%" className="text-center text-danger">
        <b>Details Not Found</b>
      </td>
    </tr>
  ) : (
    filteredData.map((row, i) => (
      <tr key={row.district_code}>
        {/* Sl.No */}
        <td className="sticky-col sticky-sno text-center">{i + 1}</td>

        {/* District Name */}
        <td className="sticky-col sticky-KPIHOD indicator-column">
          {row.district_name}
        </td>

        {/* ================= TARGETS ================= */}
        <td className="text-end">{row.dist_tr_m_count }</td>
        <td className="text-end">{row.mand_tr_m_count }</td>

        <td className="text-end">{row.dist_tr_q_count }</td>
        <td className="text-end">{row.mand_tr_q_count }</td>

        <td className="text-end">{row.dist_tr_h_count }</td>
        <td className="text-end">{row.mand_tr_h_count }</td>

        <td className="text-end">{row.dist_tr_a_count }</td>
        <td className="text-end">{row.mand_tr_a_count }</td>

        <td className="text-end">{row.dist_tot_tr_ind_count }</td>
        <td className="text-end">{row.mand_tot_tr_ind_count }</td>
        <td className="text-end">{row.dm_total_targets }</td>

        {/* ========== ACHIEVEMENTS COMPLETED ========== */}
        <td className="text-end">{row.dist_ind_ac_m_count }</td>
        <td className="text-end">{row.mand_ind_ac_m_count }</td>

        <td className="text-end">{row.dist_ind_ac_q_count }</td>
        <td className="text-end">{row.mand_ind_ac_q_count }</td>

        <td className="text-end">{row.dist_ind_ac_h_count }</td>
        <td className="text-end">{row.mand_ind_ac_h_count }</td>

        <td className="text-end">{row.dist_ind_ac_a_count }</td>
        <td className="text-end">{row.mand_ind_ac_a_count }</td>

        <td className="text-end">{row.dist_ind_ac_tot_count }</td>
        <td className="text-end">{row.mand_ind_ac_tot_count }</td>
        <td className="text-end">{row.dm_total_ac }</td>

        <td className="text-end">{row.dist_ac_per }</td>
        <td className="text-end">{row.mand_ac_per }</td>
        <td className="text-end">{row.dm_total_per }</td>


        {/* ===== ACHIEVEMENTS NOT COMPLETED ===== */}
        <td className="text-end">{row.dist_ac_m_pend }</td>
        <td className="text-end">{row.mand_ac_m_pend }</td>

        <td className="text-end">{row.dist_ac_q_pend }</td>
        <td className="text-end">{row.mand_ac_q_pend }</td>

        <td className="text-end">{row.dist_ac_h_pend }</td>
        <td className="text-end">{row.mand_ac_h_pend }</td>

        <td className="text-end">{row.dist_ac_a_pend }</td>
        <td className="text-end">{row.mand_ac_a_pend }</td>

        <td className="text-end">{row.dist_tot_ac_pend_count }</td>
        <td className="text-end">{row.mand_tot_ac_pend_count }</td>
        <td className="text-end">{row.dm_ac_tot_pend }</td>

        <td className="text-end">{row.dist_ac_pend_per }</td>
        <td className="text-end">{row.mand_ac_pend_per }</td>

        <td className="text-end">{row.dm_ac_pend_total_per }</td>
      </tr>
    ))
  )}
</tbody>

</Table>
          </div>
        </div>
      </Container>
      <AlertModal show={showAlert} titleText={alertData.titleText} alertText={alertData.alertText} onClose={closeAlert} />
    </>
  );
}
